import(/* webpackMode: "eager" */ "/home/runner/work/marbles-stack/marbles-stack/apps/game-widget/src/app/[gameId]/page.tsx");
